import { decodeHTML } from './utils';

export default class MessageHelper {

  private static messageCache: Record<string, string> = {};

  static getMessage(code: string): string {
    if (MessageHelper.messageCache[code]) {
      return MessageHelper.messageCache[code];
    }

    const rawMessage = window.ACC.messages[code];
    if (rawMessage === undefined) {
      return code;
    }

    const message = decodeHTML(rawMessage);
    this.messageCache[code] = message;
    return message;
  }

  static getMessageWithAttributes(code: string, ...args: string[] | number[]): string {
    const rawMessage = window.ACC.messages[code];
    if (rawMessage === undefined) {
      return code;
    }

    let message = decodeHTML(rawMessage);
    args.forEach((attribute, index: number) => {
      message = message.replace(`{${index}}`, attribute);
    });

    return message;
  }
}
